import ClearIcon from '@mui/icons-material/Clear';
import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  onRevertFilters: () => void;
}

export const EmployeeClearFilterButton: React.FC<Props> = ({ onRevertFilters }) => {
  const { t } = useTranslation('common');
  return (
    <Tooltip title={t('clearFilter')}>
      <Button onClick={onRevertFilters} size="small" variant="topBarButtonBorder">
        <ClearIcon />
      </Button>
    </Tooltip>
  );
};
